//
//
//
//
//
//
//
//
//
//

export default {
  props: ['market', 'event', 'outcome', 'label'],
  data() {
    return {
      lastUpdate: +new Date(),
      currentTime: +new Date(),
      showMovement: false,
      disabled: false,
      loading: true,
      movement: 0,
      balance: null
    }
  },
  computed: {
      selected() {
        return false
      },
      processingStatus: {
        get() {
          return this.$store.state.betbuilder.processingStatus
        },
        set(value) {
          this.$store.commit('betbuilder/setProcessingStatus', value)
        }
      }
  },
  filters: {
    format_odds(value, oddsFormat) {
      return _.get(value, 'display_odds.' + oddsFormat, parseFloat(_.get(value, 'odds')).toFixed(2))
    }
  },
  watch: {},

  mounted() {},
  methods: {
    addToSlip(market) {
      this.$store.commit('setBetSlipType', 'betbuilder')
      this.$store.commit('betbuilder/setPrecannedLoading', true)

      this.$store.commit('betbuilder/clear')
      this.$store.commit('betbuilder/setEvent', _.get(market, 'id'))
      this.$store.commit('betbuilder/setPrecannedId', _.get(market, 'hash'))

      for (let outcome of _.get(market, 'selections', [])) {
        this.$store.commit('betbuilder/add', outcome)
      }
      setTimeout(() => {
        this.$root.$emit('betbuilder_added')
      }, 1)
      
      this.$emit('display-builder')

      this.$store.commit('betslip/toggleBetslip', true)
      this.$root.$emit('show_betslip')

    }
  }
}
